<template>
    <div class="" @keydown="progressbar.userKeyDown()" @keyup="progressbar.userKeyUp()" @click="calculate_progress">
        <h3 
            class="
                mx-5 mt-5 mb-15
                md:mx-15 md:mt-15
                2xl:mx-20 2xl:mt-20 2xl:mb-20
            "
        >
            Situation Personnelle
        </h3>
        <!-- BEGIN Situation professionnelle -->

        <!-- BEGIN Button to add a "Evenements" -->
        <div
            v-if="$can(infosPage.name_page+'_edit', infosPass.id_pass)"
            class="w-max cursor-pointer text-gray-900 hover:text-gray-600 relative mx-5 md:mx-15 2xl:mx-20"
            id="form-add-evenement"
        >
            <add-button 
                libelle="Ajouter un évènement"
                @add="displayDropdownMenu()"
                :with-dropdown="true"
            />
            <!-- BEGIN Menu dropdown type de evenements -->
            <transition
                enter-active-class="ease-out duration-150"
                enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100 translate-y-0 sm:scale-100"
                leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
                <div
                    class="z-20 absolute left-20
                    mt-1 w-max ml-auto
                    rounded-md bg-white shadow-md shadow-gray-600
                    text-sm font-normal"
                    v-if="dropDownMenu"
                    v-clickOutside="forceHide"
                >
                    <div class="mx-5 my-3 text-left ">
                        <div 
                            class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                            v-for="(type, index) in typeEvenements" :key="index"
                            @click="addSituation(type)"
                        >
                            {{type}}
                        </div>
                    </div>
                </div>
            </transition>
            <!-- END Menu dropdown type de evenements -->
        </div>
        <!-- END Button to add a "Evenements" -->

        <!-- BEGIN list of evenements -->
        <div v-if="form.evenements.length > 0" >
            <list-grid
                :list-items="form.evenements"
                :is-accordion-items="true"
                @displayNum="(num) => {situationDisplayed = num}"
                ref="listSituations"
            >
                <template #header>
                    <div class="col-start-2 col-span-4 md:col-start-2 md:col-span-3">Période</div>
                    <div class="hidden md:block md:col-span-4">Type d'évènement</div>
                    <div class="col-span-6 md:col-span-4">Intitulé</div>
                </template>

                <template #accordionDescription="{item, num}">
                    <icon
class="text-pink-600 col-span-1 justify-self-end md:justify-self-center
                        transform transition-transform ease-in-out duration-300"
                        :class="{'rotate-90': situationDisplayed == num}"
                        name="chevron-right"
                    />
                    <div class="col-span-4 md:col-span-3 text-base"> <!-- Période -->
                        <span v-if="item.value.date_evenement">
                            {{('0' + new Date(item.value.date_evenement).getDate()).slice(-2)}}/{{('0' + (new Date(item.value.date_evenement).getMonth()+1)).slice(-2)}}/{{new Date(item.value.date_evenement).getFullYear()}}
                        </span>
                        <span class="hidden lg:inline" v-if="item.value.date_evenement && item.value.date_fin_evenement">-</span>
                        <span class="hidden lg:inline" v-if="item.value.date_fin_evenement">
                            {{('0' + new Date(item.value.date_fin_evenement).getDate()).slice(-2)}}/{{('0' + (new Date(item.value.date_fin_evenement).getMonth()+1)).slice(-2)}}/{{new Date(item.value.date_fin_evenement).getFullYear()}}
                        </span>
                    </div>
                    <div class="md:col-span-4 hidden md:block"> <!-- Type de evenements -->
                        <span
                            :class="decorationByEvent[item.type].bg+' '+decorationByEvent[item.type].color+' '+decorationByEvent[item.type].border+' border-opacity-25 border rounded-large px-4 xl:px-5 py-0.5 xl:py-1 text-base'"
                        >
                            <span class="hidden md:inline">{{item.type}}</span>
                            <span class="md:hidden">{{item.type.match(/\b(\w)/g).join(' ').toUpperCase()}}</span>
                        </span>
                    </div>
                    <div class="col-span-6 md:col-span-4 text-sm italic line-clamp-2 mr-5"> <!-- Intitulé -->
                        {{item.value.intitule_evenement}}
                    </div>
                </template>

                <template #accordionContent="{item, num}">
                    <div class="grid grid-cols-12 gap-x-4 gap-y-10">
                        <date-picker
                            name="date_evenement"
                            :necessary-date="true"
                            :libelle="evenementIsPeriod.includes(item.type) ? 'Début' : 'Date'"
                            class="col-span-full md:col-span-3"
                            format="dd/MM/yyyy"
                            initialview="year"
                            :value="item.value.date_evenement" @input="(newValue) => {item.value.date_evenement = newValue; sortEvenements()}"
                        />

                        <date-picker
                            v-if="evenementIsPeriod.includes(item.type)"
                            :necessary-date="true"
                            name="date_fin_evenement"
                            libelle="Fin"
                            class="col-span-full md:col-span-3"
                            format="dd/MM/yyyy"
                            initialview="year"
                            :value="item.value.date_fin_evenement" @input="(newValue) => {item.value.date_fin_evenement = newValue}"
                        />

                        <input-text
                            class="md:col-span-6"
                            name="intitule_evenement"
                            libelle="intitulé"
                            :necessary="true"
                            :value="item.value.intitule_evenement" @input="(newValue) => {item.value.intitule_evenement = newValue}"
                            :maxlength="50"
                            :error="true"
                        />

                        <input-text-area
                            class="md:col-span-full"
                            name="commentaire_event"
                            libelle="Commentaire"
                            :value="item.value.commentaire_event"
                            @input="(newValue) => {item.value.commentaire_event = newValue}"
                        />


                        <!-- BEGIN button to delete a evenements -->
                        <div
                            class="col-span-full w-max-content w-max cursor-pointer flex text-gray-900 hover:text-gray-600 items-center"
                            @click="deleteItem(form.evenements, num)"
                        >
                            <span class="minus-button 2xl:h-10 2xl:w-10 2xl:mt-2">
                                <icon name="close" />
                            </span>
                            <span class="text-base ml-3">
                                Supprimer cet évènement
                            </span>
                        </div>
                        <!-- END button to delete a evenements -->
                    </div>
                </template>
            </list-grid>
            <!-- END list of evenements -->
        </div>
        <!-- END Situation professionnelle -->
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ClickOutside from 'vue-click-outside';
import VerifyDates from '../../../mixins/VerifyDates';

import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import AddButton from '../../../components/Inputs/AddButton.vue';

import ListGrid from '../../../components/AccordionTable/ListGrid.vue';
import Icon from '../../../components/Icon';

export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    DatePicker,
    Icon,
    AddButton,
    ListGrid
  },

  props:['progressbar'],

  name: 'Evenements',
  mixins: [VerifyDates],

  data() {
    return {
      // Initial state of the form
      form:{
        evenements: [],
      },

      typeEvenements: [
        'Hospitalisation',
        'Déménagement',
        'Naissance',
        'Mariage',
        'Divorce',
        'Arrêt maladie',
        'Reconversion',
        'Autre'
      ],

      evenementIsPeriod:[
        'Hospitalisation',
        'Arrêt maladie',
        'Autre'
      ],

      decorationByEvent:{
        'Hospitalisation':{color:'text-indigo-600', bg:'bg-indigo-200', border:'border-indigo-600', icon:'hospital'},
        'Arrêt maladie': {color:'text-indigo-600', bg:'bg-indigo-200', border:'border-indigo-600', icon:'person-remove'},
        'Naissance': {color:'text-pink-600', bg:'bg-pink-100', border:'border-pink-600', icon:'nipple'},
        'Mariage': {color:'text-pink-600', bg:'bg-pink-100', border:'border-pink-600', icon:'love'},
        'Divorce': {color:'text-pink-600', bg:'bg-pink-100', border:'border-pink-600', icon:'heart-broken'},
        'Déménagement': {color:'text-orange-600', bg:'bg-orange-100', border:'border-orange-600', icon:'home'},
        'Reconversion': {color:'text-teal-600', bg:'bg-teal-100', border:'border-teal-600', icon:'briefcase'},
        'Autre': {color:'text-gray-600', bg:'bg-gray-200', border:'border-gray-600', icon:'more-horizontal'},
      },

      dropDownMenu: false,
      situationDisplayed: -1,
    };
  },
  async mounted(){
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)

    await this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },
  methods: {
    ...mapMutations({
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
    }),

    initForm(){
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);

      //sort evenements list
      this.sortEvenements(false);
    },
    async addSituation(el){
      let emptyContent = {};

      emptyContent.date_evenement = '';
      emptyContent.date_fin_evenement = '';
      emptyContent.intitule_evenement = '';
      emptyContent.commentaire_event = '';


      await this.form.evenements.unshift({type: el, value: emptyContent});

      this.dropDownMenu = false;
      await this.$refs.listSituations.displayNum(0, true);
    },

    deleteItem(el, index){
      el.splice(index, 1);
      this.sortEvenements();
      this.$refs.listSituations.displayNum(-1);
    },

    displayDropdownMenu(){
      this.dropDownMenu = !this.dropDownMenu;
    },

    forceHide(e){
      if(e.target.classList.contains('dropdown-menu')){
        this.displayDropdownMenu();
      }else{
        if(this.dropDownMenu){
          this.dropDownMenu = false;
        }
      }
    },
        
    sortEvenements(sorting = true){
      let evenementsDisplayed = this.form.evenements[this.situationDisplayed];
      this.form.evenements.sort(function(p1, p2){
        let date1 = new Date(p1.value.date_evenement);
        let date2 = new Date(p2.value.date_evenement);

        if(date1 < date2){
          return 1;
        }
        else if(date1 > date2){
          return -1;
        }
        else{
          return 0;
        }
      });
      if(sorting){
        this.$refs.listSituations.displayNum(this.form.evenements.indexOf(evenementsDisplayed), true);
      }
            
    }
  },
  computed:{
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
    }),
  },
  watch:{
    form: {
      handler(){
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    }
  },
  directives: {
    ClickOutside,
  }                                      
};
</script>
